import React from "react";
import RefRouter from "../../router/referensi";

const ReferensiLayout = () => {
  return (
    <div
      className="kt-content kt-grid__item kt-grid__item--fluid"
      id="kt_content"
    >
      <RefRouter />
    </div>
  );
};

export default ReferensiLayout;
